import React, { useState, useEffect, useContext, Component } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import toast from "react-hot-toast";
import axiosInstance from '../../axiosInstance';
import axios from 'axios';
import getDecryptData from '../../helpers/getDecryptData';

const Dashboard = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [limit, setlimit] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
  const [isUserdata, setisUserdata] = useState(null);

    const fetchData = async () => {
        // try {
        //     setLoading(true);
        //     const response = await axiosInstance.get(`/admin/all-order?page=${currentPage}&limit=${limit}&search=${searchTerm}&status=1,2,3,4`);
        //     setData(response.data.Order || []);
        //     setCurrentPage(response.data.currentPage);
        //     setTotalPages(response.data.totalPages);
        //     console.log(response.data)
        // } catch (error) {
        //     console.error('Error fetching data:', error);
        //     setLoading(false);
        // } finally {
        //     setLoading(false);
        // }

    };

    useEffect(() => {
        fetchData(currentPage);
    }, [currentPage, limit]);


    useEffect(() => {
        const fetchData = async () => {
          const mydata = await getDecryptData();
          if (mydata) {
            const mydatatype = mydata;
            setisUserdata(mydatatype);
          }
        };
        fetchData();
      }, []);
    



    // useEffect(() => {
    //     const checkUserToken = async () => {
    //         console.log('Effect is running');
    //         // Check if this is printed multiple times
    //         const usertoken = localStorage.getItem('adminToken');
    //         if (!usertoken) {
    //             console.log('Token !found in local storage');

    //             navigate('/admin');

    //             toast.success("Please login first");
    //         }
    //     }
    //     checkUserToken();
    // }, [navigate]);

    function formatDate(dateString) {
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return new Date(dateString).toLocaleDateString('en-US', options);
    }

    return (
        <>
            <Sidebar />
            <main class="content">
                <Navbar />


{(isUserdata && isUserdata.type === 0 ) && (
    <>
     <div className="py-4">
                    <div className="dropdown">
                        <Link
                            to="/addBlog#blogs"
                            className="btn btn-gray-800 d-inline-flex align-items-center me-2 dropdown-toggle"
                        >
                            <svg
                                className="icon icon-xs me-2"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                />
                            </svg>
                            Add Blog
                        </Link>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xl-4 col-md-6">
                        <div className="card bg-primary text-white mb-4">
                            <div className="card-body">All Blogs</div>
                            <div className="card-footer d-flex align-items-center justify-content-between">
                                <Link
                                    className="small text-white stretched-link"
                                    to="/allblogs"
                                >
                                    View Details
                                </Link>
                                <div className="small text-white">
                                    <svg
                                        className="svg-inline--fa fa-angle-right"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fas"
                                        data-icon="angle-right"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 256 512"
                                        data-fa-i2svg=""
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M246.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 41.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                                        />
                                    </svg>
                                    {/* <i class="fas fa-angle-right"></i> Font Awesome fontawesome.com */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="card bg-warning text-white mb-4">
                            <div className="card-body">Add Blogs</div>
                            <div className="card-footer d-flex align-items-center justify-content-between">
                                <Link
                                    className="small text-white stretched-link"
                                    to="/addBlog#blogs"
                                >
                                    View Details
                                </Link>
                                <div className="small text-white">
                                    <svg
                                        className="svg-inline--fa fa-angle-right"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fas"
                                        data-icon="angle-right"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 256 512"
                                        data-fa-i2svg=""
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M246.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 41.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                                        />
                                    </svg>
                                    {/* <i class="fas fa-angle-right"></i> Font Awesome fontawesome.com */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="card bg-success text-white mb-4">
                            <div className="card-body">Gallery</div>
                            <div className="card-footer d-flex align-items-center justify-content-between">
                                <Link className="small text-white stretched-link" to="/add-gallery">
                                    View Details
                                </Link>
                                <div className="small text-white">
                                    <svg
                                        className="svg-inline--fa fa-angle-right"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fas"
                                        data-icon="angle-right"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 256 512"
                                        data-fa-i2svg=""
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M246.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 41.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                                        />
                                    </svg>
                                    {/* <i class="fas fa-angle-right"></i> Font Awesome fontawesome.com */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    </>
)}

           {(isUserdata && isUserdata.type === 1 ) && (
    <>
               <div className="row mt-3">
                    <div className="col-xl-4 col-md-6">
                        <div className="card bg-primary text-white mb-4">
                            <div className="card-body">All Enquire</div>
                            <div className="card-footer d-flex align-items-center justify-content-between">
                                <Link
                                    className="small text-white stretched-link"
                                    to="/all-enquire"
                                >
                                    View Details
                                </Link>
                                <div className="small text-white">
                                    <svg
                                        className="svg-inline--fa fa-angle-right"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fas"
                                        data-icon="angle-right"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 256 512"
                                        data-fa-i2svg=""
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M246.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 41.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                                        />
                                    </svg>
                                    {/* <i class="fas fa-angle-right"></i> Font Awesome fontawesome.com */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="card bg-warning text-white mb-4">
                            <div className="card-body">Buy Plan</div>
                            <div className="card-footer d-flex align-items-center justify-content-between">
                                <Link
                                    className="small text-white stretched-link"
                                    to="/buy-plan"
                                >
                                    View Details
                                </Link>
                                <div className="small text-white">
                                    <svg
                                        className="svg-inline--fa fa-angle-right"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fas"
                                        data-icon="angle-right"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 256 512"
                                        data-fa-i2svg=""
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M246.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 41.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                                        />
                                    </svg>
                                    {/* <i class="fas fa-angle-right"></i> Font Awesome fontawesome.com */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="card bg-success text-white mb-4">
                            <div className="card-body">Transaction</div>
                            <div className="card-footer d-flex align-items-center justify-content-between">
                                <Link className="small text-white stretched-link" to="/all-transaction">
                                    View Details
                                </Link>
                                <div className="small text-white">
                                    <svg
                                        className="svg-inline--fa fa-angle-right"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fas"
                                        data-icon="angle-right"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 256 512"
                                        data-fa-i2svg=""
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M246.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 41.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                                        />
                                    </svg>
                                    {/* <i class="fas fa-angle-right"></i> Font Awesome fontawesome.com */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

</>
)}


                

            </main>
        </>
    )
}

export default Dashboard